import { createContext, useContext, useState } from "react";

const PlanDrawerContext = createContext();

export const PlanDrawerProvider = ({children}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const [eligibleForFreePlan, setEligibleForFreePlan] = useState(false);

  const openDrawer = (planData, eligibleForFreePlan = false) => {
    setPlan(planData);
    setEligibleForFreePlan(eligibleForFreePlan);
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setPlan(null);
    setEligibleForFreePlan(false);
    setIsOpen(false);
  };

  return(
    <PlanDrawerContext.Provider value={{ isOpen, plan, eligibleForFreePlan, openDrawer, closeDrawer }}>
      {children}
    </PlanDrawerContext.Provider>
  );
};

export const usePlanDrawer = () => useContext(PlanDrawerContext);